// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1wOG6","buttons":"RemoveExpirationActionButtons_buttons__1uYG5"};